"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-9b708cc2"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = { class: "order-ended" };
var _hoisted_2 = { class: "main-block" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("h1", { class: "heading" }, [
    /*#__PURE__*/ vue_2.createTextVNode("Вы "),
    /*#__PURE__*/ vue_2.createElementVNode("span", { style: { "color": "" } }, "успешно"),
    /*#__PURE__*/ vue_2.createTextVNode(" оформили заказ!")
], -1); });
var _hoisted_4 = { class: "number" };
var _hoisted_5 = {
    class: "label",
    style: { "margin-left": "12px" }
};
var _hoisted_6 = /*#__PURE__*/ vue_2.createStaticVNode("<p data-v-9b708cc2>В ближайшее время с вами свяжется наш менеджер <br data-v-9b708cc2> для уточнения заказа</p><div class=\"btns\" data-v-9b708cc2><div class=\"default-btn\" data-v-9b708cc2><i class=\"termi-printer\" data-v-9b708cc2></i> Распечатать </div><div class=\"default-btn download\" data-v-9b708cc2><i class=\"termi-arrow-left rotate270\" data-v-9b708cc2></i> Скачать </div></div>", 2);
var _hoisted_8 = { class: "more" };
var _hoisted_9 = { class: "col" };
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("h2", { class: "heading2" }, "В заказе", -1); });
var _hoisted_11 = { class: "left-right" };
var _hoisted_12 = { class: "item" };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "Товаров", -1); });
var _hoisted_14 = { class: "item__right" };
var _hoisted_15 = { class: "item" };
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "На сумму", -1); });
var _hoisted_17 = { class: "item__right" };
var _hoisted_18 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("h2", { class: "heading2" }, "Получатель", -1); });
var _hoisted_19 = { class: "left-right" };
var _hoisted_20 = { class: "item" };
var _hoisted_21 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "ФИО", -1); });
var _hoisted_22 = { class: "item__right" };
var _hoisted_23 = { class: "item" };
var _hoisted_24 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "E-mail", -1); });
var _hoisted_25 = { class: "item__right" };
var _hoisted_26 = { class: "item" };
var _hoisted_27 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "Телефон", -1); });
var _hoisted_28 = { class: "item__right" };
var _hoisted_29 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("h2", { class: "heading2" }, "Отгрузка", -1); });
var _hoisted_30 = { class: "left-right" };
var _hoisted_31 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/ vue_2.createElementVNode("div", { class: "item__left" }, "Примерная дата"),
    /*#__PURE__*/ vue_2.createElementVNode("div", { class: "item__right" }, /*#__PURE__*/ vue_2.toDisplayString('Дата'))
], -1); });
var _hoisted_32 = { class: "item" };
var _hoisted_33 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__left" }, "Адрес", -1); });
var _hoisted_34 = { class: "item__right" };
var _hoisted_35 = { class: "col" };
var _hoisted_36 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("h2", { class: "heading2" }, "Состав заказа", -1); });
var axios_1 = require("axios");
var OrderPositionsTable_vue_1 = require("vue_components/OrderPositionsTable.vue");
var vue_3 = require("vue");
var helpers_1 = require("vue_components/helpers");
var vue_router_1 = require("vue-router");
exports.default = vue_1.defineComponent({
    setup: function (__props) {
        var route = vue_router_1.useRoute();
        var order = vue_3.ref({
            positions: [],
            state: {},
            store: {},
        });
        var urlParams = helpers_1.decomposeUrlParams();
        function getQueryVariable(variable) {
            var _a;
            return (_a = urlParams[variable]) !== null && _a !== void 0 ? _a : '';
        }
        function getEndedOrderData() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, axios_1.default.get('/order/view/?order_id=' + route.params.id + '&hash=' + urlParams.hash)];
                        case 1:
                            res = _a.sent();
                            order.value = res.data.data.order;
                            return [2 /*return*/];
                    }
                });
            });
        }
        getEndedOrderData();
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                vue_2.createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    vue_2.createElementVNode("div", _hoisted_4, [
                        vue_2.createTextVNode("№ " + vue_2.toDisplayString(order.value.number) + " ", 1),
                        vue_2.createElementVNode("span", _hoisted_5, vue_2.toDisplayString(order.value.state.value), 1)
                    ]),
                    _hoisted_6
                ]),
                vue_2.createElementVNode("div", _hoisted_8, [
                    vue_2.createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        vue_2.createElementVNode("div", _hoisted_11, [
                            vue_2.createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                vue_2.createElementVNode("div", _hoisted_14, vue_2.toDisplayString(order.value.positions.length), 1)
                            ]),
                            vue_2.createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                vue_2.createElementVNode("div", _hoisted_17, vue_2.toDisplayString(vue_2.unref(helpers_1.priceStringFormat)(order.value.total_cost)), 1)
                            ])
                        ]),
                        _hoisted_18,
                        vue_2.createElementVNode("div", _hoisted_19, [
                            vue_2.createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                vue_2.createElementVNode("div", _hoisted_22, vue_2.toDisplayString(order.value.name), 1)
                            ]),
                            vue_2.createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                vue_2.createElementVNode("div", _hoisted_25, vue_2.toDisplayString(order.value.email), 1)
                            ]),
                            vue_2.createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                vue_2.createElementVNode("div", _hoisted_28, vue_2.toDisplayString(order.value.phone), 1)
                            ])
                        ]),
                        _hoisted_29,
                        vue_2.createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            vue_2.createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                vue_2.createElementVNode("div", _hoisted_34, vue_2.toDisplayString(order.value.delivery_address), 1)
                            ])
                        ])
                    ]),
                    vue_2.createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        vue_2.createVNode(OrderPositionsTable_vue_1.default, {
                            disabled: true,
                            compact: true,
                            items: order.value.positions
                        }, null, 8, ["items"])
                    ])
                ])
            ]));
        };
    }
});
